import { Message, ProtobufMessageClass } from '@ms/yammer-protobuf';
import { noop } from 'lodash';

import { GetReportAnalyticsEvent } from './usageV2';

export const MockedProtobufEventV1: ProtobufMessageClass<Message> = {} as unknown as ProtobufMessageClass<Message>;

export const mockedGetReportAnalyticsEvent: GetReportAnalyticsEvent =
  (_MessageClass, _loggingOptions) => (_plainMessage) =>
    noop;
